import React from 'react';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  NPISearchItemDTO,
} from 'dtos/nPISearchItemDTO';
import {
  formatPhone,
  formatZipCode,
} from '@populateui/utils';
import {
  getAddressString,
} from 'utils/string';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';

const npiColumn = {
  id: 'npi',
  accessorKey: 'npi',
  size: 80,
  header: 'NPI',
};
const credentialColumn = {
  id: 'credentials',
  accessorKey: 'credential',
  header: 'Credentials',
  size: 80,
};
const addressColumn: ColumnDef<NPISearchItemDTO> = {
  id: 'address',
  accessorKey: 'state',
  header: 'Address',
  size: 180,
  cell: ({ row: { original } }) => (
    <>
      {getAddressString({
        ...original,
        street: original.addressLine1,
        zipCode: formatZipCode(original.postalCode ?? ''),
      })}
      <br />
      {original?.phoneNumber ? `Phone: ${formatPhone(original.phoneNumber)}` : ''}
    </>
  ),
};
const taxonomyColumn = {
  id: 'taxonomy',
  accessorKey: 'taxonomy',
  header: 'Taxonomy',
  size: 120,
};

export const organizationColumns: ColumnDef<NPISearchItemDTO>[] = [{
  id: 'name',
  accessorKey: 'organizationName',
  meta: 180,
  header: 'Name',
}, npiColumn, addressColumn, taxonomyColumn];
export const individualColumns: ColumnDef<NPISearchItemDTO>[] = [{
  id: 'name',
  accessorKey: 'name',
  meta: 180,
  header: 'Name',
  cell: ({ row: { original } }) => getDisplayName(original?.formattedNames, '--'),
}, npiColumn, credentialColumn, addressColumn, taxonomyColumn];
